import React from 'react';
import { Wrapper, Loading } from './styled';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';

interface Props {
  id?: string;
  className?: string;
  text?: string;
  background?: string;
  color?: string;
  disabled?: boolean;
  width?: number;
  title?: string;
  loading?: boolean;
  handleClick?: Function;
  left?: boolean;
  to?: string;
  blank?: boolean;
  children?: React.ReactNode;
  border?: string;
  icon?: {
    name: string;
    color: string;
    width: string;
  },
  refButton?: any;
  type?: string;
}

const Button: React.FC<Props> = ({
  id,
  className,
  background,
  color,
  disabled,
  width,
  title,
  loading,
  handleClick,
  text,
  left,
  to,
  blank,
  border,
  icon,
  children,
  refButton,
  type
}) => {

  const Content: React.FC = () => (
    <React.Fragment>
      {
        loading ?
          <Loading color={color} left={left}><Icon data-name="icon-circle" width={icon && icon.width || '16'} height={icon && icon.width || '16'} /></Loading>
        :
          icon && <Icon data-name={icon.name} fill={icon.color} width={icon.width} height={icon.width} />
      }
    </React.Fragment>
  );

  const props = {
    type: type,
    id,
    className,
    background,
    color,
    disabled,
    width,
    title,
    loading,
    onClick: e => handleClick && handleClick(e),
    href: to,
    target: blank && '_blank',
    text,
    left,
    border,
    ref: refButton
  };

  return (
    left && <Wrapper {...props}><Content /><span>{text}</span>{children}</Wrapper> ||
    <Wrapper {...props}><span>{text}</span>{children}<Content /></Wrapper>
  )
};

Button.defaultProps = {
  background: COLORS.GRAY_LIGHT,
  color: COLORS.BLACK
}

export { Button };
